var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransicationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2126_182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.19225 5.94123C8.92353 5.55614 8.24778 5.26995 7.36459 5.53748C6.55363 5.78314 6.19025 7.08823 7.24797 7.58982C7.41394 7.66854 7.83925 7.83657 8.48094 8.06467C9.91713 8.5752 9.96434 10.4721 8.25981 10.6218C7.69184 10.6717 6.88194 10.5182 6.45097 9.98013M7.92981 10.6816V11.1236M7.92981 4.87635V5.40182M7.91884 14.072H15.2127M14.457 14.9952L15.375 14.072L14.457 13.1489M7.95412 1.92792H0.787313M1.54297 1.00476L0.625 1.92792L1.54297 2.85107",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.755 6.43754C13.0694 3.84123 10.7163 1.92798 7.9188 1.92798C4.58414 1.92798 1.88086 4.64654 1.88086 8.00004C1.88086 11.3535 4.58414 14.0721 7.9188 14.0721C10.7163 14.0721 13.0694 12.1589 13.755 9.56254",
    stroke: "white",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2126_182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransicationIcon);
export default __webpack_public_path__ + "static/media/transication-icon.06a79cb5c3ffbc8fd2e1c01add320556.svg";
export { ForwardRef as ReactComponent };